import { useState, useEffect, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import buildParams from "../utils/buildParams";
import useAxios from "../api/useAxios";

export const useGetList = (endpoint, immediate = true, params) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiInstance = useAxios();

  const fetchData = useCallback(
    async (url, customParams) => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiInstance.get(url ? url : endpoint, {
          params: customParams || params,
        });

        // setData(response.data.list || response.data.data || response.data);
        setData(response.data);

        // Update pagination if available

        return response.data;
      } catch (err) {
        console.log(err);
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          "An error occurred while fetching data";
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [endpoint],
  );

  const refetch = useCallback(() => {
    return fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (immediate) {
      fetchData();
    }
  }, [immediate, fetchData]);

  console.log(data);

  return {
    data,
    loading,
    error,
    refetch,
    fetchData,
  };
};
